import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './resource-library.component.scss';
import * as $ from 'jquery';
var ResourceLibrary = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceLibrary, _super);
    function ResourceLibrary(element) {
        return _super.call(this, element) || this;
    }
    ResourceLibrary.prototype.init = function () {
        this.detailContainerGrid = this.element.querySelector('.resource-library__details');
        this.detailContainerList = this.element.querySelector('.resource-library__results');
        this.scrollTopOffset = this.element.getBoundingClientRect().y;
        this.buttonTypeGrid = this.element.querySelector('.js-view-grid');
        this.buttonTypeList = this.element.querySelector('.js-view-list');
        this.containerGrid = this.element.querySelector('.js-list-grid');
        this.containerList = this.element.querySelector('.js-list-normal');
    };
    ResourceLibrary.prototype.bindEvents = function () {
        var _this = this;
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	SHARE COMPONET
        //////////////////////////////////////////
        //////////////////////////////////////////
        $(document).on('click touch', 'div.resource-library__item--share', function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var infoTarget = event.target;
            if (infoTarget.closest('.js-info-button')) {
                _this.closeShareContainers();
            }
            else {
                _this.closeShareContainers();
                _this.closeDetail();
                var details = element.querySelector('.resource-library__item--share__details');
                details.classList.add('open');
            }
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	GRID CLICK
        //////////////////////////////////////////
        //////////////////////////////////////////
        $(document).on('click touch', '.resource-library__item', function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var elementTarget = event.target;
            if (elementTarget.closest('.resource-library__item--share')) {
            }
            else {
                _this.closeShareContainers();
                _this.createDetail(element);
                // $('html, body').animate({
                // 	scrollTop: this.scrollTopOffset
                // }, 500);
            }
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	LIST CLICK
        //////////////////////////////////////////
        //////////////////////////////////////////
        $(document).on('click touch', '.resource-library__table--row', function (event) {
            console.log('Testing');
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var elementTarget = event.target;
            if (elementTarget.closest('.resource-library__item--share')) {
            }
            else {
                _this.closeShareContainers();
                _this.createDetail(element);
                // $('html, body').animate({
                // 	scrollTop: this.scrollTopOffset
                // }, 500);
            }
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	DETAIL CLOSE
        //////////////////////////////////////////
        //////////////////////////////////////////
        $(document).on('click touch', 'div.resource-library__detail', function (event) {
            _this.closeDetail();
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	BUTTON CLICK LIST VIEW
        //////////////////////////////////////////
        //////////////////////////////////////////
        this.buttonTypeList.addEventListener('click', function (e) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            element.classList.add('d-none');
            _this.containerGrid.classList.add('d-none');
            _this.buttonTypeGrid.classList.remove('d-none');
            _this.containerList.classList.remove('d-none');
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	BUTTON CLICK LIST GRID
        //////////////////////////////////////////
        //////////////////////////////////////////
        this.buttonTypeGrid.addEventListener('click', function (e) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            element.classList.add('d-none');
            _this.containerList.classList.add('d-none');
            _this.buttonTypeList.classList.remove('d-none');
            _this.containerGrid.classList.remove('d-none');
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        ////	INFO BUTTON CLICK
        //////////////////////////////////////////
        //////////////////////////////////////////
        $(document).on('click touch', '.js-info-button', function (event) {
            var element = undefined;
            var parentElement = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            console.log('Info Clicked');
            if (element.closest('.resource-library__item')) {
                parentElement = element.closest('.resource-library__item');
            }
            else {
                parentElement = element.closest('.resource-library__table--row');
            }
            _this.createDetail(parentElement);
        });
    };
    //////////////////////////////////////////
    //////////////////////////////////////////
    ////	CLOSE SHARE CONTAINERS
    //////////////////////////////////////////
    //////////////////////////////////////////
    ResourceLibrary.prototype.closeShareContainers = function () {
        var buttonsShare = Array.from(this.element.querySelectorAll('div.resource-library__item--share'));
        buttonsShare.map(function (item) {
            var details = item.querySelector('.resource-library__item--share__details');
            details.classList.remove('open');
        });
    };
    //////////////////////////////////////////
    //////////////////////////////////////////
    ////	CREATE DETAIL
    //////////////////////////////////////////
    //////////////////////////////////////////
    ResourceLibrary.prototype.createDetail = function (element) {
        if (element === void 0) { element = undefined; }
        var valueImage = '';
        var valueType = '';
        var valueCreated = '';
        var valueModified = '';
        var valueTags = '';
        var valueName = '';
        var valueDescription = '';
        var valueMailto = '';
        var valueDownload = '';
        if (element.getAttribute('data-image')) {
            var value = element.getAttribute('data-image');
            if (value !== '') {
                valueImage = "<div class=\"resource-library__detail--image__container\">\n\t\t\t\t\t<img src=\"" + value + "\" alt=\"\">\n\t\t\t\t</div>";
            }
        }
        if (element.getAttribute('data-type')) {
            var value = element.getAttribute('data-type');
            if (value !== '') {
                valueType = "<div class=\"resource-library__detail--meta__type\">\n\t\t\t\t\t" + value + "\n\t\t\t\t</div>";
            }
        }
        if (element.getAttribute('data-created')) {
            var value = element.getAttribute('data-created');
            if (value !== '') {
                valueCreated = "<div class=\"resource-library__detail--meta__type\">\n\t\t\t\t\t<strong>Created:</strong> " + value + "\n\t\t\t\t</div>";
            }
        }
        if (element.getAttribute('data-modified')) {
            var value = element.getAttribute('data-modified');
            if (value !== '') {
                valueModified = "<div class=\"resource-library__detail--meta__type\">\n\t\t\t\t\t<strong>Modified:</strong> " + value + "\n\t\t\t\t</div>";
            }
        }
        if (element.getAttribute('data-name')) {
            var value = element.getAttribute('data-name');
            if (value !== '') {
                valueName = "<div class=\"resource-library__detail--meta__type text-left\"><strong>" + value + "</strong></div>";
            }
        }
        if (element.getAttribute('data-description')) {
            var value = element.getAttribute('data-description');
            if (value !== '') {
                valueDescription = "<div class=\"resource-library__detail--details__name--value\">\n\t\t\t\t\t" + value + "\n\t\t\t\t</div>";
            }
        }
        if (element.getAttribute('data-sharebutton')) {
            var mailToAddress = '';
            var mailToSubject = '';
            var mailToBody = '';
            var mailToButton = 'Share';
            var valueMailToSubject = element.getAttribute('data-subject');
            var valueMailToBody = element.getAttribute('data-body');
            var valueMailToButton = element.getAttribute('data-sharebutton');
            if (valueMailToSubject !== '') {
                mailToSubject = valueMailToSubject;
            }
            if (valueMailToBody !== '') {
                mailToBody = valueMailToBody;
            }
            if (valueMailToButton !== '') {
                mailToButton = valueMailToButton;
            }
            valueMailto = "<a href=\"mailto:?subject=" + mailToSubject + "&body=" + mailToBody + "\" class=\"button button--white button--border-blue button--full\">" + mailToButton + "</a>";
        }
        if (element.getAttribute('data-download')) {
            var url = '';
            var urlButton = 'Download';
            var valueUrl = element.getAttribute('data-download');
            var valueUrlButton = element.getAttribute('data-downloadbutton');
            if (valueUrl !== '') {
                url = valueUrl;
            }
            if (valueUrlButton !== '') {
                urlButton = valueUrlButton;
            }
            valueDownload = "<a href=\"" + url + "\" download=\"" + url + "\" class=\"button button--main button--full\">" + urlButton + "</a>";
        }
        if (this.detailContainerGrid.querySelector('.resource-library__detail')) {
            var detail = this.detailContainerGrid.querySelector('.resource-library__detail');
            detail.remove();
        }
        if (this.detailContainerList.querySelector('.resource-library__detail')) {
            var detail = this.detailContainerList.querySelector('.resource-library__detail');
            detail.remove();
        }
        var html = "<div class=\"resource-library__detail open ui-kit__palette--shadow\">\n\t\t\t<div class=\"resource-library__detail--header\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\">\n\t\t\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t\t\t<title>icon-close</title>\n\t\t\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t\t\t<defs><linearGradient xy=\"100%\" id=\"gradient\"><stop stop-color=\"#fff\" offset=\"0%\"></stop><stop stop-color=\"#fff\" offset=\"100%\"></stop></linearGradient></defs>\n\t\t\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-239.000000, -1047.000000)\">\n\t\t\t\t\t\t<g id=\"icon-close\" transform=\"translate(240.000000, 1047.000000)\" fill=\"#000000\" stroke=\"#000000\" stroke-width=\"0.25\">\n\t\t\t\t\t\t\t<path d=\"M19.89,20.361 C20.0192516,20.50942 20.0117716,20.7325081 19.8728687,20.8719371 C19.7339658,21.0113662 19.5109076,21.0196895 19.362,20.891 L10,11.528 L0.64,20.89 C0.493364607,21.0356781 0.256635393,21.0356781 0.11,20.89 C0.0395894888,20.8199889 -4.752856e-07,20.7247935 -4.752856e-07,20.6255 C-4.752856e-07,20.5262065 0.0395894888,20.4310111 0.11,20.361 L9.472,11.001 L0.11,1.638 C0.0153246163,1.54332462 -0.0216503308,1.40533224 0.0130032636,1.27600327 C0.0476568579,1.14667429 0.148674288,1.04565686 0.278003266,1.01100326 C0.407332243,0.976349669 0.545324619,1.01332462 0.64,1.108 L10,10.472 L19.362,1.111 C19.4564967,1.01650324 19.5942288,0.979598056 19.7233137,1.01418627 C19.8523987,1.04877448 19.9532255,1.14960131 19.9878137,1.27868627 C20.0224019,1.40777124 19.9854968,1.54550325 19.891,1.64 L10.529,11 L19.891,20.361 L19.89,20.361 Z\" id=\"Shape\"></path>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t\t<div class=\"resource-library__detail--container\">\n\t\t\t\t" + valueImage + "\n\t\t\t\t<div class=\"resource-library__detail--meta\">\n\t\t\t\t\t" + valueType + "\n\t\t\t\t\t" + valueCreated + "\n\t\t\t\t\t" + valueModified + "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"resource-library__detail--details\">\n\t\t\t\t\t" + valueTags + "\n\t\t\t\t\t<div class=\"resource-library__detail--details__description\">\n\t\t\t\t\t\t" + valueName + "\n\t\t\t\t\t\t" + valueDescription + "\n\t\t\t\t\t</div>\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"resource-library__detail--buttons\">\n\t\t\t\t\t" + valueMailto + "\n\t\t\t\t\t" + valueDownload + "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var html2 = "<div class=\"resource-library__detail open ui-kit__palette--shadow\">\n\t\t\t<div class=\"resource-library__detail--header\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\">\n\t\t\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t\t\t<title>icon-close</title>\n\t\t\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t\t\t<defs><linearGradient xy=\"100%\" id=\"gradient\"><stop stop-color=\"#fff\" offset=\"0%\"></stop><stop stop-color=\"#fff\" offset=\"100%\"></stop></linearGradient></defs>\n\t\t\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-239.000000, -1047.000000)\">\n\t\t\t\t\t\t<g id=\"icon-close\" transform=\"translate(240.000000, 1047.000000)\" fill=\"#000000\" stroke=\"#000000\" stroke-width=\"0.25\">\n\t\t\t\t\t\t\t<path d=\"M19.89,20.361 C20.0192516,20.50942 20.0117716,20.7325081 19.8728687,20.8719371 C19.7339658,21.0113662 19.5109076,21.0196895 19.362,20.891 L10,11.528 L0.64,20.89 C0.493364607,21.0356781 0.256635393,21.0356781 0.11,20.89 C0.0395894888,20.8199889 -4.752856e-07,20.7247935 -4.752856e-07,20.6255 C-4.752856e-07,20.5262065 0.0395894888,20.4310111 0.11,20.361 L9.472,11.001 L0.11,1.638 C0.0153246163,1.54332462 -0.0216503308,1.40533224 0.0130032636,1.27600327 C0.0476568579,1.14667429 0.148674288,1.04565686 0.278003266,1.01100326 C0.407332243,0.976349669 0.545324619,1.01332462 0.64,1.108 L10,10.472 L19.362,1.111 C19.4564967,1.01650324 19.5942288,0.979598056 19.7233137,1.01418627 C19.8523987,1.04877448 19.9532255,1.14960131 19.9878137,1.27868627 C20.0224019,1.40777124 19.9854968,1.54550325 19.891,1.64 L10.529,11 L19.891,20.361 L19.89,20.361 Z\" id=\"Shape\"></path>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t\t<div class=\"resource-library__detail--container\">\n\t\t\t\t" + valueImage + "\n\t\t\t\t<div class=\"resource-library__detail--meta\">\n\t\t\t\t\t" + valueType + "\n\t\t\t\t\t" + valueCreated + "\n\t\t\t\t\t" + valueModified + "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"resource-library__detail--details\">\n\t\t\t\t\t" + valueTags + "\n\t\t\t\t\t<div class=\"resource-library__detail--details__description\">\n\t\t\t\t\t\t" + valueName + "\n\t\t\t\t\t\t" + valueDescription + "\n\t\t\t\t\t</div>\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"resource-library__detail--buttons\">\n\t\t\t\t\t" + valueMailto + "\n\t\t\t\t\t" + valueDownload + "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(html));
        this.detailContainerGrid.appendChild(docfragment);
        var docfragment2 = document.createDocumentFragment();
        docfragment2.appendChild(document.createRange().createContextualFragment(html2));
        this.detailContainerList.appendChild(docfragment2);
    };
    ResourceLibrary.prototype.closeDetail = function () {
        if (this.detailContainerGrid.querySelector('.resource-library__detail')) {
            var detail = this.detailContainerGrid.querySelector('.resource-library__detail');
            detail.remove();
        }
        if (this.detailContainerList.querySelector('.resource-library__detail')) {
            var detail = this.detailContainerList.querySelector('.resource-library__detail');
            detail.remove();
        }
    };
    return ResourceLibrary;
}(Base));
export { ResourceLibrary };



//////////////////
// WEBPACK FOOTER
// ./components/resource-library/resource-library.component.ts
// module id = 479
// module chunks = 0